/** 배포 직후 구버전 main.js가 삭제된 chunk를 요청할 때 자동 새로고침 */
const RELOAD_FLAG = 'chunk_reload_attempted';

export function isChunkLoadError(message: string): boolean {
  if (!message) return false;
  return (
    message.includes('Loading chunk')
    || message.includes('ChunkLoadError')
    || message.includes('dynamically imported module')
    || message.includes("Unexpected token '<'")
    || message.includes('.chunk.js')
  );
}

/** 캐시를 우회해 index.html·main.js를 다시 받도록 강제 이동 */
export function hardReloadOnChunkError(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('_chunk_reload');
  url.searchParams.set('_chunk_reload', String(Date.now()));
  window.location.replace(url.toString());
}

export function setupChunkLoadRecovery(): void {
  const tryReload = (message: string) => {
    if (!isChunkLoadError(message)) return;
    if (sessionStorage.getItem(RELOAD_FLAG)) return;
    sessionStorage.setItem(RELOAD_FLAG, '1');
    hardReloadOnChunkError();
  };

  // script 태그 로드 실패는 bubble 단계에서 message가 비어 있음 → capture 사용
  window.addEventListener(
    'error',
    (event) => {
      const target = event.target as HTMLElement | null;
      if (target?.tagName === 'SCRIPT') {
        const src = (target as HTMLScriptElement).src || '';
        if (src.includes('/static/js/') && src.includes('.chunk.js')) {
          tryReload(`Loading chunk failed ${src}`);
          return;
        }
      }
      tryReload(event.message || '');
    },
    true,
  );

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = typeof reason === 'string' ? reason : reason?.message || String(reason);
    tryReload(message);
  });

  window.addEventListener('load', () => {
    sessionStorage.removeItem(RELOAD_FLAG);
  });
}
